import { SavedAccountsModalTranslations } from "./saved-accounts-modal-pt-br";

export const SAVED_ACCOUNTS_MODAL_ES_MX: SavedAccountsModalTranslations = {
	holderName: "Titular",
	agency: "Agencia",
	accountNumber: "Cuenta",
	pixKey: "Llave PIX",
	addAccount: "Añadir cuenta",
	title: "Cuentas guardadas",
	search: "Buscar cuenta",
	return: "Volver",
	default: "Predeterminado",
	edit: "Editar",
	delete: "Eliminar",
};
